import React, { useEffect, useRef, useState } from 'react';
import styles from 'styles/Question.module.scss';
import { Button, Row, Spinner } from 'reactstrap';
import { Radio, X } from 'react-feather';
import classnames from 'classnames';
import calendarData from 'api/userEventApi';
import {
  USER_EVENT_TYPE,
  USER_ROOM_STATUS,
  noRecord,
  UNIT_TYPE,
  CONTENT_APPROVAL,
  USER_ROLES,
} from 'constants/constants';
import moment from 'moment';
import sessionUserApi from 'api/sessionUserApi';
import { useUser, useViewMode } from 'hooks/index';
import { handleToastError } from 'helpers/index';
import { showToastSuccess } from '@core/components/toastify/ToastTypes';
import dynamic from 'next/dynamic';
import { Spin } from 'antd';
import { useSelector } from 'react-redux';
import { getColor, getColorText, getThemeColor } from 'store/settings';
import styled from '@emotion/styled';

import {
  dateConversion,
  titleExtensionWithTimeZone,
} from 'helpers/format-time';
import ModalZoom from '../../Unit/components/ContentCalendar/modalZoomLink';
import userEventApi from 'api/userEventApi';
import { getSelectedCentre } from 'store/master';
import { BsCalendar4Week } from 'react-icons/bs';
import 'antd/dist/antd.css';

const ZoomApp = dynamic(
  () => import('../../Unit/components/ContentCalendar/zoomInside'),
  {
    ssr: false,
  },
);
const CalendarCardLearner = (props) => {
  const { open, setOpen } = props;
  const day = new Date(props.date);
  const viewMode = useViewMode();
  const userLoggedIn = useUser();
  // const [isLiving, setLiving] = useState(false);
  const selectedCentre = useSelector(getSelectedCentre);
  const [lessonDatas, setLessonDatas] = useState([]);
  const [zoomLink, setZoomLink] = useState();
  const [openZoom, setOpenZoom] = useState(false);
  const [loading, setLoading] = useState(true);
  const metaData = useSelector((state) => state.settingAccount.metaData);
  const [zoom, setZoom] = useState(false);
  const asideMenuRef = useRef(null);
  const themeStatus = useSelector(getThemeColor);
  const [disableStatus, setDisableStatus] = useState(true);
  //Color Theme
  const colorStatus = useSelector(getColor);
  const colorTextStatus = useSelector(getColorText);
  const Stylescal = styled.div`
    &:has(~ div) {
      margin: 10px 0;
    }
    .btn-danger {
      border-color: ${colorStatus} !important;
      background-color: ${colorStatus} !important;
      color: ${colorTextStatus} !important;
    }
    .btn-danger:hover {
      background-color: #ffffff !important;
      color: ${colorStatus} !important;
      border-color: ${colorStatus} !important;
    }
    .btn-danger:disabled {
      border-color: ${colorStatus} !important;
      background-color: ${colorStatus} !important;
      color: ${colorTextStatus} !important;
    }
    .btn {
      padding: 0.3rem 0.9rem !important;
      font-size: 12px !important;
      border-radius: 0.3rem !important;
    }
  `;
  const getDetails = async () => {
    try {
      let begin = new Date(props.date);
      begin.setDate(begin.getDate() - 1);

      let param = {
        begin: moment(begin).format('YYYY-MM-DD') + 'T18:30:00.000Z',
        end: moment(props.date).format('YYYY-MM-DD') + 'T18:29:00.000Z',
        types: `${USER_EVENT_TYPE.EVENT},${USER_EVENT_TYPE.WEBINAR},${USER_EVENT_TYPE.CLASSROOM},${USER_EVENT_TYPE.MSTEAMS_MEETING}`,
      };
      if (selectedCentre?._id) {
        param.courseCentre = selectedCentre?._id;
      }
      const response = await calendarData.getAll(param);
      setLessonDatas(response);
      setDisableStatus(true);
    } catch (error) {
      handleToastError(error);
    } finally {
      setLoading(false);
    }
  };

  const registrations = async (data) => {
    setDisableStatus(false);
    if (data?.sessionusers?.missingUserCourse) {
      try {
        const param = {
          session: data?._id,
          unit: data?.unit?._id,
          user: userLoggedIn._id,
        };
        const response = await sessionUserApi.create(param);
        if (response) {
          setDisableStatus(false);
        }
        showToastSuccess('Registered');
        getDetails();
      } catch (e) {
        handleToastError(e);
        setDisableStatus(true);
      }
    } else {
      try {
        const response = await sessionUserApi.delete(data?.sessionusers?._id);
        if (response) {
          setDisableStatus(false);
        }
        showToastSuccess('UnRegistered');
        getDetails();
      } catch (e) {
        handleToastError(e);
        setDisableStatus(true);
      }
    }
  };

  const formatHandler = (time, title, courseInfo) => {
    try {
      const timeStart = new Date(time?.begin);
      const timeEnd = new Date(time?.end);
      var time_Start = dateConversion(timeStart);
      var time_End = dateConversion(timeEnd);
      let data = `${title} ${time_Start.nameOfDay} ${time_Start.getdate}${time_Start.nth} ${time_Start.month} ${time_Start.strTime} - ${time_End.strTime}`;
      return data;
    } catch (error) {
      handleToastError(error);
    }
  };

  const joinRoom = async (data) => {
    // toggle();
    try {
      const payload = await userEventApi.getLink(data?._id);
      if (payload.data) {
        setZoomLink(payload.data);
        setOpenZoom(true);
      }
    } catch (e) {
      handleToastError(e);
    }
  };

  const onToggle = async () => {
    setOpenZoom(!openZoom);
  };

  useEffect(() => {
    getDetails();
  }, [props.date]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        asideMenuRef?.current &&
        !asideMenuRef?.current?.contains(event.target)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div ref={asideMenuRef}>
      <section className="d-flex justify-content-between px-2 pb-1 pt-2">
        <h4
          className={classnames(
            'sub-heading_text_title Date-Name m-0',
            'w-100',
            styles['Date-Name'],
          )}
        >
          {' '}
          {moment(day).format('DD-MMM-YYYY')} -{' '}
          {day.toLocaleString('default', { weekday: 'long' })}
        </h4>

        <div className="cursor-pointer" onClick={() => setOpen(false)}>
          <X size={20} />
        </div>
      </section>
      <hr />
      <div className="m-1">
        <Spin spinning={zoom} size="large">
          {loading ? (
            <div className="p-5 text-center">
              <Spinner style={{ color: `${themeStatus}` }} />
            </div>
          ) : lessonDatas?.length ? (
            <div className="row">
              {lessonDatas?.map((data, index) => (
                <>
                  {selectedCentre?.reviewContent === false ||
                  data?.unit?.contentReviewStatus ===
                    CONTENT_APPROVAL.APPROVED ? (
                    <div
                      style={{ animationDelay: `${200 + 40 * index}ms` }}
                      className="col-12 border-bottom py-1"
                    >
                      <div
                        style={{ '--gap': '.8rem' }}
                        className="d-flex mx-0 dynamic-gap-v"
                      >
                        <section className={`px-0`}>
                          <h4 className="card-title my-0 learner-modal-content">
                            {(data?.type == 'WEBINAR' ||
                              data?.type == UNIT_TYPE.LIVESTREAMING) &&
                            data?.titleExtenstion
                              ? data.name +
                                ' ' +
                                titleExtensionWithTimeZone(
                                  data?.time?.begin,
                                  data?.time?.end,
                                  data?.timezone,
                                )
                              : (data?.type == 'WEBINAR' ||
                                  data?.type == UNIT_TYPE.LIVESTREAMING) &&
                                data?.importLesson === true
                              ? formatHandler(data?.time, data?.name)
                              : data?.name}
                          </h4>
                          <div className="d-flex justify-content-between mt-05">
                            <section>
                              <span className="learner-modal-bgColor">
                                <BsCalendar4Week className="learner-modal-icon" />
                              </span>
                              <span className="learner-modal-date">
                                {moment(data.time.begin).format('DD/MM/yyyy')} -
                                {moment(data.time.end).format('DD/MM/yyyy')}
                              </span>
                              {data?.type == 'WEBINAR' ||
                              data?.type == UNIT_TYPE.LIVESTREAMING ? (
                                <span
                                  className="learner-modal-date"
                                  style={{ color: '#c4161c' }}
                                >
                                  (Online Class)
                                </span>
                              ) : data?.type == UNIT_TYPE.CLASSROOM ? (
                                <span
                                  className="learner-modal-date"
                                  style={{ color: '#666ee8' }}
                                >
                                  (Physical Class)
                                </span>
                              ) : (
                                <span
                                  className="learner-modal-date"
                                  style={{ color: '#666ee8' }}
                                >
                                  (Microsoft Teams Meeting)
                                </span>
                              )}
                            </section>
                          </div>
                        </section>
                        <section className="px-0 ">
                          {data?.type == 'WEBINAR' ||
                          data?.type == UNIT_TYPE.LIVESTREAMING ||
                          data?.type == UNIT_TYPE.MSTEAMS_MEETING ? (
                            <div className="col-12">
                              <div className="col-md-12 ">
                                <Row className="justify-content-end">
                                  {(
                                    metaData?.cmsHomePage
                                      ? data?.isUnitAccess
                                      : true
                                  ) ? (
                                    <>
                                      {viewMode == USER_ROLES.LEARNER ? (
                                        <div>
                                          <>
                                            {!metaData?.zoomInside &&
                                              data?.optionUser ==
                                                'REGISTRY' && (
                                                <>
                                                  <Stylescal>
                                                    <button
                                                      className={classnames(
                                                        `btn btn-danger mr-1`,
                                                      )}
                                                      disabled={
                                                        disableStatus
                                                          ? false
                                                          : true
                                                      }
                                                      onClick={() =>
                                                        registrations(data)
                                                      }
                                                    >
                                                      {data?.sessionusers
                                                        ?.missingUserCourse
                                                        ? 'Register'
                                                        : 'UnRegister'}
                                                    </button>
                                                  </Stylescal>

                                                  <Stylescal>
                                                    <button
                                                      className={classnames(
                                                        `btn ${
                                                          data?.roomStatus ===
                                                          'RUNNING'
                                                            ? 'btn-danger'
                                                            : 'btn-secondary disableButton'
                                                        }`,
                                                        styles[
                                                          data?.roomStatus ===
                                                          'RUNNING'
                                                            ? ''
                                                            : 'disableButton'
                                                        ],
                                                      )}
                                                      onClick={() => {
                                                        joinRoom(data);
                                                      }}
                                                      disabled={
                                                        (data.optionUser ==
                                                        'REGISTRY'
                                                          ? !data?.sessionusers
                                                              ?.missingUserCourse
                                                          : true) &&
                                                        data.roomStatus ===
                                                          USER_ROOM_STATUS.RUNNING &&
                                                        (metaData?.cmsHomePage
                                                          ? data?.isUnitAccess
                                                          : true)
                                                          ? false
                                                          : true
                                                      }
                                                    >
                                                      Join
                                                    </button>
                                                  </Stylescal>
                                                </>
                                              )}

                                            {metaData?.zoomInside ? (
                                              zoom ? (
                                                <ZoomApp
                                                  event={data.unit}
                                                  id={data._id}
                                                  status={data.roomStatus}
                                                  disabled={
                                                    data.roomStatus ===
                                                    USER_ROOM_STATUS.RUNNING
                                                      ? false
                                                      : true
                                                  }
                                                  isLiving={
                                                    data.roomStatus ===
                                                    USER_ROOM_STATUS.RUNNING
                                                      ? true
                                                      : false
                                                  }
                                                />
                                              ) : data?.optionUser ==
                                                'REGISTRY' ? (
                                                <Stylescal>
                                                  <button
                                                    className={classnames(
                                                      `btn btn-danger mr-1 mt-1`,
                                                    )}
                                                    disabled={
                                                      disableStatus
                                                        ? false
                                                        : true
                                                    }
                                                    onClick={() =>
                                                      registrations(data)
                                                    }
                                                  >
                                                    {data?.sessionusers
                                                      ?.missingUserCourse
                                                      ? 'Register'
                                                      : 'UnRegister'}
                                                  </button>
                                                </Stylescal>
                                              ) : (
                                                <Stylescal>
                                                  <Button
                                                    color={'danger'}
                                                    disabled={
                                                      (data.optionUser ==
                                                      'REGISTRY'
                                                        ? !data?.sessionusers
                                                            ?.missingUserCourse
                                                        : true) &&
                                                      data.roomStatus ===
                                                        USER_ROOM_STATUS.RUNNING &&
                                                      (metaData?.cmsHomePage
                                                        ? data?.isUnitAccess
                                                        : true)
                                                        ? false
                                                        : true
                                                    }
                                                    className={classnames(
                                                      data.roomStatus ===
                                                        USER_ROOM_STATUS.RUNNING
                                                        ? styles[
                                                            'custom-btn-living'
                                                          ]
                                                        : '',
                                                      '',
                                                    )}
                                                    onClick={() =>
                                                      setZoom(true)
                                                    }
                                                  >
                                                    <span>Join</span>
                                                  </Button>
                                                </Stylescal>
                                              )
                                            ) : null}
                                          </>
                                        </div>
                                      ) : (
                                        <div>
                                          <>
                                            {!metaData?.zoomInside && (
                                              <Stylescal>
                                                <button
                                                  className={classnames(
                                                    `btn btn-danger mr-1`,
                                                  )}
                                                  onClick={() => {
                                                    joinRoom(data);
                                                  }}
                                                >
                                                  {data.roomStatus ===
                                                  USER_ROOM_STATUS.RUNNING
                                                    ? 'Join'
                                                    : 'Start'}
                                                </button>
                                              </Stylescal>
                                            )}

                                            {metaData?.zoomInside ? (
                                              zoom ? (
                                                <ZoomApp
                                                  event={data.unit}
                                                  id={data._id}
                                                  status={data.roomStatus}
                                                  disabled={
                                                    data.roomStatus ===
                                                    USER_ROOM_STATUS.RUNNING
                                                      ? false
                                                      : true
                                                  }
                                                  isLiving={
                                                    data.roomStatus ===
                                                    USER_ROOM_STATUS.RUNNING
                                                      ? true
                                                      : false
                                                  }
                                                />
                                              ) : (
                                                <Stylescal>
                                                  <button
                                                    className={classnames(
                                                      `btn btn-danger mr-1`,
                                                    )}
                                                    color={'danger'}
                                                    onClick={() =>
                                                      setZoom(true)
                                                    }
                                                  >
                                                    <span>
                                                      {data.roomStatus ===
                                                      USER_ROOM_STATUS.RUNNING
                                                        ? 'Join'
                                                        : 'Start'}
                                                    </span>
                                                  </button>
                                                </Stylescal>
                                              )
                                            ) : null}
                                          </>
                                        </div>
                                      )}
                                      <div></div>
                                    </>
                                  ) : null}
                                </Row>
                              </div>
                            </div>
                          ) : null}
                          <div className="d-flex justify-content-end px-1 mt-05">
                            {data?.roomStatus === 'RUNNING' && (
                              <span
                                className={classnames(
                                  'flashit',
                                  styles['flashit'],
                                )}
                              >
                                <Radio
                                  className={classnames(
                                    'liveIcon',
                                    styles['liveIcon'],
                                  )}
                                  color="#db0506"
                                  size={18}
                                />
                              </span>
                            )}
                          </div>
                        </section>
                      </div>
                    </div>
                  ) : null}
                </>
              ))}
            </div>
          ) : (
            <div>
              <p className="text-center">{noRecord}</p>
            </div>
          )}
        </Spin>
      </div>

      <ModalZoom open={openZoom} toggle={onToggle} link={zoomLink} />
    </div>
  );
};

export default CalendarCardLearner;
